import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toggleAutoUpdates } from "reducers/actions/ContentFeedActions";
import ContentFeedConfirmModal from "./ContentFeedConfirmModal";

const buildTitle = contentFeedName => `Switch off auto updates for "${contentFeedName}"?`;

export default function ToggleAutoUpdatesModal({ onClose }) {
	const dispatch = useDispatch();

	function handleConfirm(contentFeedId) {
		return dispatch(toggleAutoUpdates(Number(contentFeedId), false));
	}

	return (
		<ContentFeedConfirmModal
			onClose={onClose}
			confirmLabel="Switch Off"
			confirmingLabel="Switching Off..."
			buildTitle={buildTitle}
			onConfirm={handleConfirm}
		/>
	);
}

ToggleAutoUpdatesModal.displayName = "ToggleAutoUpdatesModal";

ToggleAutoUpdatesModal.propTypes = {
	onClose: PropTypes.func.isRequired,
};
